import { M } from "@angular/material/form-field-control.d-QxD-9xJ3"
import { EMAIL_FIELD, FIRST_NAME_FIELD, INT_ADDRESS_FIELDS, LAST_NAME_FIELD, MIDDLE_NAME_FIELD, US_ADDRESS_FIELDS } from "./generic.fields"
import { DateTime } from "luxon"

const duration_options = [
	{label: "Less than 24 hours", value: "H"},
	{ label: "Days", value: "D" },
	{ label: "Weeks", value: "W" },
	{ label: "Months", value: "M" },
	{ label: "Years", value: "Y" }
]
const citizenship_options = [
	{ "label": "AFGHANISTAN", "value": "AFGH" },
	{ "label": "ALBANIA", "value": "ALB" },
	{ "label": "ALGERIA", "value": "ALGR" },
	{ "label": "ANDORRA", "value": "ANDO" },
	{ "label": "ANGOLA", "value": "ANGL" },
	{ "label": "ANGUILLA", "value": "ANGU" },
	{ "label": "ANTIGUA AND BARBUDA", "value": "ANTI" },
	{ "label": "ARGENTINA", "value": "ARG" },
	{ "label": "ARMENIA", "value": "ARM" },
	{ "label": "AUSTRALIA", "value": "ASTL" },
	{ "label": "AUSTRIA", "value": "AUST" },
	{ "label": "AZERBAIJAN", "value": "AZR" },
	{ "label": "BAHAMAS", "value": "BAMA" },
	{ "label": "BAHRAIN", "value": "BAHR" },
	{ "label": "BANGLADESH", "value": "BANG" },
	{ "label": "BARBADOS", "value": "BRDO" },
	{ "label": "BELARUS", "value": "BYS" },
	{ "label": "BELGIUM", "value": "BELG" },
	{ "label": "BELIZE", "value": "BLZ" },
	{ "label": "BENIN", "value": "BENN" },
	{ "label": "BERMUDA", "value": "BERM" },
	{ "label": "BHUTAN", "value": "BHU" },
	{ "label": "BOLIVIA", "value": "BOL" },
	{ "label": "BOSNIA-HERZEGOVINA", "value": "BIH" },
	{ "label": "BOTSWANA", "value": "BOT" },
	{ "label": "BRAZIL", "value": "BRZL" },
	{ "label": "BRUNEI", "value": "BRNI" },
	{ "label": "BULGARIA", "value": "BULG" },
	{ "label": "BURKINA FASO", "value": "BURK" },
	{ "label": "BURMA", "value": "BURM" },
	{ "label": "BURUNDI", "value": "BRND" },
	{ "label": "CAMBODIA", "value": "CBDA" },
	{ "label": "CAMEROON", "value": "CMRN" },
	{ "label": "CANADA", "value": "CAN" },
	{ "label": "CABO VERDE", "value": "CAVI" },
	{ "label": "CAYMAN ISLANDS", "value": "CAYI" },
	{ "label": "CENTRAL AFRICAN REPUBLIC", "value": "CAFR" },
	{ "label": "CHAD", "value": "CHAD" },
	{ "label": "CHILE", "value": "CHIL" },
	{ "label": "CHINA", "value": "CHIN" },
	{ "label": "COLOMBIA", "value": "COL" },
	{ "label": "COMOROS", "value": "COMO" },
	{ "label": "CONGO, DEMOCRATIC REPUBLIC OF THE", "value": "COD" },
	{ "label": "CONGO, REPUBLIC OF THE", "value": "CONB" },
	{ "label": "COSTA RICA", "value": "CSTR" },
	{ "label": "COTE D`IVOIRE", "value": "IVCO" },
	{ "label": "CROATIA", "value": "HRV" },
	{ "label": "CUBA", "value": "CUBA" },
	{ "label": "CYPRUS", "value": "CYPR" },
	{ "label": "CZECH REPUBLIC", "value": "CZEC" },
	{ "label": "DENMARK", "value": "DEN" },
	{ "label": "DJIBOUTI", "value": "DJI" },
	{ "label": "DOMINICA", "value": "DOMN" },
	{ "label": "DOMINICAN REPUBLIC", "value": "DOMR" },
	{ "label": "ECUADOR", "value": "ECUA" },
	{ "label": "EGYPT", "value": "EGYP" },
	{ "label": "EL SALVADOR", "value": "ELSL" },
	{ "label": "EQUATORIAL GUINEA", "value": "EGN" },
	{ "label": "ERITREA", "value": "ERI" },
	{ "label": "ESTONIA", "value": "EST" },
	{ "label": "ESWATINI", "value": "SZLD" },
	{ "label": "ETHIOPIA", "value": "ETH" },
	{ "label": "FIJI", "value": "FIJI" },
	{ "label": "FINLAND", "value": "FIN" },
	{ "label": "FRANCE", "value": "FRAN" },
	{ "label": "GABON", "value": "GABN" },
	{ "label": "GAMBIA, THE", "value": "GAM" },
	{ "label": "GEORGIA", "value": "GEO" },
	{ "label": "GERMANY", "value": "GER" },
	{ "label": "GHANA", "value": "GHAN" },
	{ "label": "GIBRALTAR", "value": "GIB" },
	{ "label": "GREECE", "value": "GRC" },
	{ "label": "GRENADA", "value": "GREN" },
	{ "label": "GUATEMALA", "value": "GUAT" },
	{ "label": "GUINEA", "value": "GNEA" },
	{ "label": "GUINEA - BISSAU", "value": "GUIB" },
	{ "label": "GUYANA", "value": "GUY" },
	{ "label": "HAITI", "value": "HAT" },
	{ "label": "HOLY SEE (VATICAN CITY)", "value": "VAT" },
	{ "label": "HONDURAS", "value": "HOND" },
	{ "label": "HONG KONG BNO", "value": "HOKO" },
	{ "label": "HONG KONG SAR", "value": "HNK" },
	{ "label": "HUNGARY", "value": "HUNG" },
	{ "label": "ICELAND", "value": "ICLD" },
	{ "label": "INDIA", "value": "IND" },
	{ "label": "INDONESIA", "value": "IDSA" },
	{ "label": "IRAN", "value": "IRAN" },
	{ "label": "IRAQ", "value": "IRAQ" },
	{ "label": "IRELAND", "value": "IRE" },
	{ "label": "ISRAEL", "value": "ISRL" },
	{ "label": "ITALY", "value": "ITLY" },
	{ "label": "JAMAICA", "value": "JAM" },
	{ "label": "JAPAN", "value": "JPN" },
	{ "label": "JORDAN", "value": "JORD" },
	{ "label": "KAZAKHSTAN", "value": "KAZ" },
	{ "label": "KENYA", "value": "KENY" },
	{ "label": "KIRIBATI", "value": "KIRI" },
	{ "label": "KOREA, DEMOCRATIC REPUBLIC OF (NORTH)", "value": "PRK" },
	{ "label": "KOREA, REPUBLIC OF (SOUTH)", "value": "KOR" },
	{ "label": "KOSOVO", "value": "KSV" },
	{ "label": "KUWAIT", "value": "KUWT" },
	{ "label": "KYRGYZSTAN", "value": "KGZ" },
	{ "label": "LAOS", "value": "LAOS" },
	{ "label": "LATVIA", "value": "LATV" },
	{ "label": "LEBANON", "value": "LEBN" },
	{ "label": "LESOTHO", "value": "LES" },
	{ "label": "LIBERIA", "value": "LIBR" },
	{ "label": "LIBYA", "value": "LBYA" },
	{ "label": "LIECHTENSTEIN", "value": "LCHT" },
	{ "label": "LITHUANIA", "value": "LITH" },
	{ "label": "LUXEMBOURG", "value": "LXM" },
	{ "label": "MACAU", "value": "MAC" },
	{ "label": "MACEDONIA, NORTH", "value": "MKD" },
	{ "label": "MADAGASCAR", "value": "MADG" },
	{ "label": "MALAWI", "value": "MALW" },
	{ "label": "MALAYSIA", "value": "MLAS" },
	{ "label": "MALDIVES", "value": "MLDV" },
	{ "label": "MALI", "value": "MALI" },
	{ "label": "MALTA", "value": "MLTA" },
	{ "label": "MARSHALL ISLANDS", "value": "RMI" },
	{ "label": "MAURITANIA", "value": "MAUR" },
	{ "label": "MAURITIUS", "value": "MRTS" },
	{ "label": "MEXICO", "value": "MEX" },
	{ "label": "MICRONESIA", "value": "FSM" },
	{ "label": "MOLDOVA", "value": "MLD" },
	{ "label": "MONACO", "value": "MON" },
	{ "label": "MONGOLIA", "value": "MONG" },
	{ "label": "MONTENEGRO", "value": "MTG" },
	{ "label": "MONTSERRAT", "value": "MONT" },
	{ "label": "MOROCCO", "value": "MORO" },
	{ "label": "MOZAMBIQUE", "value": "MOZ" },
	{ "label": "NAMIBIA", "value": "NAMB" },
	{ "label": "NAURU", "value": "NAU" },
	{ "label": "NEPAL", "value": "NEP" },
	{ "label": "NETHERLANDS", "value": "NETH" },
	{ "label": "NEW ZEALAND", "value": "NZLD" },
	{ "label": "NICARAGUA", "value": "NIC" },
	{ "label": "NIGER", "value": "NIR" },
	{ "label": "NIGERIA", "value": "NRA" },
	{ "label": "NORWAY", "value": "NORW" },
	{ "label": "OMAN", "value": "OMAN" },
	{ "label": "PAKISTAN", "value": "PKST" },
	{ "label": "PALAU", "value": "PALA" },
	{ "label": "PALESTINIAN AUTHORITY", "value": "PAL" },
	{ "label": "PANAMA", "value": "PAN" },
	{ "label": "PAPUA NEW GUINEA", "value": "PNG" },
	{ "label": "PARAGUAY", "value": "PARA" },
	{ "label": "PERU", "value": "PERU" },
	{ "label": "PHILIPPINES", "value": "PHIL" },
	{ "label": "PITCAIRN ISLANDS", "value": "PITC" },
	{ "label": "POLAND", "value": "POL" },
	{ "label": "PORTUGAL", "value": "PORT" },
	{ "label": "QATAR", "value": "QTAR" },
	{ "label": "ROMANIA", "value": "ROM" },
	{ "label": "RUSSIA", "value": "RUS" },
	{ "label": "RWANDA", "value": "RWND" },
	{ "label": "SAMOA", "value": "WSAM" },
	{ "label": "SAN MARINO", "value": "SMAR" },
	{ "label": "SAO TOME AND PRINCIPE", "value": "STPR" },
	{ "label": "SAUDI ARABIA", "value": "SARB" },
	{ "label": "SENEGAL", "value": "SENG" },
	{ "label": "SERBIA", "value": "SBA" },
	{ "label": "SEYCHELLES", "value": "SEYC" },
	{ "label": "SIERRA LEONE", "value": "SLEO" },
	{ "label": "SINGAPORE", "value": "SING" },
	{ "label": "SLOVAKIA", "value": "SVK" },
	{ "label": "SLOVENIA", "value": "SVN" },
	{ "label": "SOLOMON ISLANDS", "value": "SLMN" },
	{ "label": "SOMALIA", "value": "SOMA" },
	{ "label": "SOUTH AFRICA", "value": "SAFR" },
	{ "label": "SOUTH SUDAN", "value": "SSDN" },
	{ "label": "SPAIN", "value": "SPN" },
	{ "label": "SRI LANKA", "value": "SRL" },
	{ "label": "ST. HELENA", "value": "SHEL" },
	{ "label": "ST. KITTS AND NEVIS", "value": "STCN" },
	{ "label": "ST. LUCIA", "value": "SLCA" },
	{ "label": "ST. VINCENT AND THE GRENADINES", "value": "STVN" },
	{ "label": "STATELESS", "value": "XXX" },
	{ "label": "SUDAN", "value": "SUDA" },
	{ "label": "SURINAME", "value": "SURM" },
	{ "label": "SWEDEN", "value": "SWDN" },
	{ "label": "SWITZERLAND", "value": "SWTZ" },
	{ "label": "SYRIA", "value": "SYR" },
	{ "label": "TAIWAN", "value": "TWAN" },
	{ "label": "TAJIKISTAN", "value": "TJK" },
	{ "label": "TANZANIA", "value": "TAZN" },
	{ "label": "THAILAND", "value": "THAI" },
	{ "label": "TIMOR-LESTE", "value": "TMOR" },
	{ "label": "TOGO", "value": "TOGO" },
	{ "label": "TONGA", "value": "TONG" },
	{ "label": "TRINIDAD AND TOBAGO", "value": "TRIN" },
	{ "label": "TUNISIA", "value": "TNSA" },
	{ "label": "TURKEY", "value": "TRKY" },
	{ "label": "TURKMENISTAN", "value": "TKM" },
	{ "label": "TURKS AND CAICOS ISLANDS", "value": "TCIS" },
	{ "label": "TUVALU", "value": "TUV" },
	{ "label": "UGANDA", "value": "UGAN" },
	{ "label": "UKRAINE", "value": "UKR" },
	{ "label": "UNITED ARAB EMIRATES", "value": "UAE" },
	{ "label": "UNITED KINGDOM", "value": "GRBR" },
	{ "label": "URUGUAY", "value": "URU" },
	{ "label": "UZBEKISTAN", "value": "UZB" },
	{ "label": "VANUATU", "value": "VANU" },
	{ "label": "VENEZUELA", "value": "VENZ" },
	{ "label": "VIETNAM", "value": "VTNM" },
	{ "label": "VIRGIN ISLANDS, BRITISH", "value": "BRVI" },
	{ "label": "WALLIS AND FUTUNA ISLANDS", "value": "WAFT" },
	{ "label": "WESTERN SAHARA", "value": "SSAH" },
	{ "label": "YEMEN", "value": "YEM" },
	{ "label": "ZAMBIA", "value": "ZAMB" },
	{ "label": "ZIMBABWE", "value": "ZIMB" }
]

const securityField = {
	answer: {
		type: "yes-no-buttons"
	},
	description: {
		type: "textarea",
		props: {
			label: "Please provide a brief description",
			maxLength: 4000
		}
	}
}

export const US_FIELDS = {
	renounce_us_citizenship: securityField,
	voted_in_violation_of_us_law: securityField,
	withheld_custody_of_us_children: securityField,
	deported_from_other_countries: securityField,
	us_visa_fraud: securityField,
	coercive_transplantation_of_human_organs: securityField,
	population_control: securityField,
	religious_freedom_violations: securityField,
	child_soldiers: securityField,
	extrajudicial_killings: securityField,
	torture: securityField,
	genocide: securityField,
	terrorist_relative: securityField,
	terrorist_org_member: securityField,
	terrorist_activities_support: securityField,
	terrorist_activities: securityField,
	espionage: securityField,
	human_trafficking_relative: securityField,
	human_trafficking: securityField,
	human_trafficking_aid: securityField,
	controlled_substances: securityField,
	money_laundering: securityField,
	prostitution: securityField,
	criminal_history: securityField,
	drug_abuse: securityField,
	communicable_disease: securityField,
	mental_disorder: securityField,
	employment: {
		previous: {
			type: "yes-no-buttons"
		},
		salary: {
			type: "input",
			props: {
				min: 0,
				step: 0.01,
				type: "number",
				label: "Monthly Salary",
			}
		},
		field: {
			type: "select",
			props: {
				label: "Field of Employment",
				options: [
					{ "label": "AGRICULTURE", "value": "A" },
					{ "label": "ARTIST/PERFORMER", "value": "AP" },
					{ "label": "BUSINESS", "value": "B" },
					{ "label": "COMMUNICATIONS", "value": "CM" },
					{ "label": "COMPUTER SCIENCE", "value": "CS" },
					{ "label": "CULINARY/FOOD SERVICES", "value": "C" },
					{ "label": "EDUCATION", "value": "ED" },
					{ "label": "ENGINEERING", "value": "EN" },
					{ "label": "GOVERNMENT", "value": "G" },
					{ "label": "HOMEMAKER", "value": "H" },
					{ "label": "LEGAL PROFESSION", "value": "LP" },
					{ "label": "MEDICAL/HEALTH", "value": "MH" },
					{ "label": "MILITARY", "value": "M" },
					{ "label": "NATURAL SCIENCE", "value": "NS" },
					{ "label": "NOT EMPLOYED", "value": "N" },
					{ "label": "PHYSICAL SCIENCES", "value": "PS" },
					{ "label": "RELIGIOUS VOCATION", "value": "RV" },
					{ "label": "RESEARCH", "value": "R" },
					{ "label": "RETIRED", "value": "RT" },
					{ "label": "SOCIAL SCIENCE", "value": "SS" },
					{ "label": "STUDENT", "value": "S" },
					{ "label": "OTHER", "value": "O" }
				]
			}
		},
		field_details: {
			type: "input",
			props: {
				label: "Field of Employment",
				maxLength: 50
			}
		}
	},
	married: {
		spouse: {
			address_type: {
				type: "select",
				props: {
					label: "Address Type",
					options: [
						{ label: "Same as Your Home Address", value: "H" },
						{ label: "Same as Your Mailing Address", value: "M" },
						{ label: "Same as U.S. Contact Address", value: "U" },
						{ label: "Do Not Know", value: "D" },
						{ label: "Other (Specify Address)", value: "O" }
					]
				}
			}
		}
	},
	marital_status: {
		type: "select",
		props: {
			label: "Marital Status",
			options: [
				{ label: "Common Law Marriage", value: "C" },
				{ label: "Civil Union/Domestic Partnership", value: "P" },
				{ label: "Single", value: "S" },
				{ label: "Widowed", value: "W" },
				{ label: "Divorced", value: "D" },
				{ label: "Legally Separated", value: "L" },
				{ label: "Other", value: "O" }
			]
		}
	},
	relatives_in_us: {
		non_immediate_relatives: {
			type: "yes-no-buttons"
		},
		answer: {
			type: "yes-no-buttons"
		},
		list: {
			type: "array",
			fieldArray: {
				fieldGroup: [
					{
						fieldGroup: [          
							{
								key: "given_name",
								type: "name-field",
								props: {
									label: "Given Names",
									maxLength: 33
								}
							},
							{
								key: "last_name",
								type: "name-field",
								props: {
									label: "Last Name",
									maxLength: 33
								}
							}
						],
						fieldGroupClassName: "gwc-form__field-group gwc-form__field-group--row"
					},
					{
						fieldGroup: [
							{
								key: "relationship",
								type: "select",
								props: {
									label: "Relationship",
									options: [
										{ label: "Spouse", value: "S" },
										{ label: "Fiancé/Fiancée", value: "F" },
										{ label: "Child", value: "C" },
										{ label: "Sibling", value: "B" }
									]
								}
							},
							{
								key: "status_in_us",
								type: "select",
								props: {
									label: "Status in the United States",
									options: [
										{ label: "U.S. Citizen", value: "S" },
										{ label: "U.S. Legal Permanent Resident (LPR)", value: "C" },
										{ label: "Nonimmigrant", value: "P" },
										{ label: "Other/I Don't Know", value: "O" }
									]
								}
							}
						]
					},
				]
			}
		}
	},
	other_phone_number: {
		answer: {
			type: "yes-no-buttons"
		},
		list: {
			type: "array",
			fieldArray: {
				fieldGroup: [
					{
						key: "phone_number",
						type: "input",
						props: {
							label: "Phone Number",
							maxLength: 15
						}
					}
				]
			}
		}
	},
	other_email_address: {
		answer: {
			type: "yes-no-buttons"
		},
		list: {
			type: "array",
			fieldArray: {
				fieldGroup: [
					{
						key: "email_address",
						...EMAIL_FIELD
					}
				]
			}
		}
	},
	ten_fingers_provided: {
		answer: {
			type: "yes-no-buttons"
		}
	},
	contact: {
		answer: {
			type: "buttons",
			props: {
				options: [
					{
						label: "Person",
						value: "person"
					},
					{
						label: "Company",
						value: "company"
					},
					{
						label: "None",
						value: "none"
					}
				]
			}
		},
		person: {
			given_name: {
				type: "name-field",
				props: {
					label: "Given Name",
					maxLength: 33
				}
			},
			last_name: {
				type: "name-field",
				props: {
					label: "Last Name",
					maxLength: 33
				}
			},
			
		},
		company: {
			name: {
				type: "input",
				props: {
					label: "Company Name",
					maxLength: 33
				}
			},
		},
		contact_info: {
			relationship: {
				type: "mapped-select",
				props: {
					label: "Relationship",
					options: {
						person: [
							{ label: "Relative", value: "R" },
							{ label: "Spouse", value: "S" },
							{ label: "Friend", value: "F" },
							{ label: "Business Associate", value: "B" },
							{ label: "Employer", value: "P" },
							{ label: "School Official", value: "H" },
							{ label: "Other", value: "O" }
						],
						company: [
							{ label: "Business Associate", value: "B" },
							{ label: "Employer", value: "P" },
							{ label: "School Official", value: "H" },
							{ label: "Other", value: "O" }
						],
						none: [
							{ label: "Business Associate", value: "B" },
							{ label: "Employer", value: "P" },
							{ label: "School Official", value: "H" },
							{ label: "Other", value: "O" }
						]
					}
				}
			},
			address: {
				fieldGroup: US_ADDRESS_FIELDS
			},
			phone_number: {
				type: "input",
				props: {
					label: "Phone Number",
					maxLength: 15
				}
			},
			email_address: EMAIL_FIELD
		}
	},
	birth_country: {
		type: 'autocomplete',
		props: {
			label: 'Birth Country',
			options: [
				{ "label": "AFGHANISTAN", "value": "AFGH" },
				{ "label": "ALBANIA", "value": "ALB" },
				{ "label": "ALGERIA", "value": "ALGR" },
				{ "label": "AMERICAN SAMOA", "value": "ASMO" },
				{ "label": "ANDORRA", "value": "ANDO" },
				{ "label": "ANGOLA", "value": "ANGL" },
				{ "label": "ANGUILLA", "value": "ANGU" },
				{ "label": "ANTIGUA AND BARBUDA", "value": "ANTI" },
				{ "label": "ARGENTINA", "value": "ARG" },
				{ "label": "ARMENIA", "value": "ARM" },
				{ "label": "ARUBA", "value": "ARB" },
				{ "label": "AT SEA", "value": "XAS" },
				{ "label": "AUSTRALIA", "value": "ASTL" },
				{ "label": "AUSTRIA", "value": "AUST" },
				{ "label": "AZERBAIJAN", "value": "AZR" },
				{ "label": "BAHAMAS", "value": "BAMA" },
				{ "label": "BAHRAIN", "value": "BAHR" },
				{ "label": "BANGLADESH", "value": "BANG" },
				{ "label": "BARBADOS", "value": "BRDO" },
				{ "label": "BELARUS", "value": "BYS" },
				{ "label": "BELGIUM", "value": "BELG" },
				{ "label": "BELIZE", "value": "BLZ" },
				{ "label": "BENIN", "value": "BENN" },
				{ "label": "BERMUDA", "value": "BERM" },
				{ "label": "BHUTAN", "value": "BHU" },
				{ "label": "BOLIVIA", "value": "BOL" },
				{ "label": "BOSNIA-HERZEGOVINA", "value": "BIH" },
				{ "label": "BOTSWANA", "value": "BOT" },
				{ "label": "BRAZIL", "value": "BRZL" },
				{ "label": "BRITISH INDIAN OCEAN TERRITORY", "value": "IOT" },
				{ "label": "BRUNEI", "value": "BRNI" },
				{ "label": "BULGARIA", "value": "BULG" },
				{ "label": "BURKINA FASO", "value": "BURK" },
				{ "label": "BURMA", "value": "BURM" },
				{ "label": "BURUNDI", "value": "BRND" },
				{ "label": "CAMBODIA", "value": "CBDA" },
				{ "label": "CAMEROON", "value": "CMRN" },
				{ "label": "CANADA", "value": "CAN" },
				{ "label": "CABO VERDE", "value": "CAVI" },
				{ "label": "CAYMAN ISLANDS", "value": "CAYI" },
				{ "label": "CENTRAL AFRICAN REPUBLIC", "value": "CAFR" },
				{ "label": "CHAD", "value": "CHAD" },
				{ "label": "CHILE", "value": "CHIL" },
				{ "label": "CHINA", "value": "CHIN" },
				{ "label": "CHRISTMAS ISLAND", "value": "CHRI" },
				{ "label": "COCOS KEELING ISLANDS", "value": "COCI" },
				{ "label": "COLOMBIA", "value": "COL" },
				{ "label": "COMOROS", "value": "COMO" },
				{ "label": "CONGO, DEMOCRATIC REPUBLIC OF THE", "value": "COD" },
				{ "label": "CONGO, REPUBLIC OF THE", "value": "CONB" },
				{ "label": "COOK ISLANDS", "value": "CKIS" },
				{ "label": "COSTA RICA", "value": "CSTR" },
				{ "label": "COTE D`IVOIRE", "value": "IVCO" },
				{ "label": "CROATIA", "value": "HRV" },
				{ "label": "CUBA", "value": "CUBA" },
				{ "label": "CURACAO", "value": "CUR" },
				{ "label": "CYPRUS", "value": "CYPR" },
				{ "label": "CZECH REPUBLIC", "value": "CZEC" },
				{ "label": "DENMARK", "value": "DEN" },
				{ "label": "DJIBOUTI", "value": "DJI" },
				{ "label": "DOMINICA", "value": "DOMN" },
				{ "label": "DOMINICAN REPUBLIC", "value": "DOMR" },
				{ "label": "ECUADOR", "value": "ECUA" },
				{ "label": "EGYPT", "value": "EGYP" },
				{ "label": "EL SALVADOR", "value": "ELSL" },
				{ "label": "EQUATORIAL GUINEA", "value": "EGN" },
				{ "label": "ERITREA", "value": "ERI" },
				{ "label": "ESTONIA", "value": "EST" },
				{ "label": "ESWATINI", "value": "SZLD" },
				{ "label": "ETHIOPIA", "value": "ETH" },
				{ "label": "FALKLAND ISLANDS", "value": "FKLI" },
				{ "label": "FAROE ISLANDS", "value": "FRO" },
				{ "label": "FIJI", "value": "FIJI" },
				{ "label": "FINLAND", "value": "FIN" },
				{ "label": "FRANCE", "value": "FRAN" },
				{ "label": "FRENCH POLYNESIA", "value": "FPOL" },
				{ "label": "FRENCH SOUTHERN AND ANTARCTIC TERRITORIES", "value": "FSAT" },
				{ "label": "GABON", "value": "GABN" },
				{ "label": "GAMBIA, THE", "value": "GAM" },
				{ "label": "GAZA STRIP", "value": "XGZ" },
				{ "label": "GEORGIA", "value": "GEO" },
				{ "label": "GERMANY", "value": "GER" },
				{ "label": "GHANA", "value": "GHAN" },
				{ "label": "GIBRALTAR", "value": "GIB" },
				{ "label": "GREECE", "value": "GRC" },
				{ "label": "GREENLAND", "value": "GRLD" },
				{ "label": "GRENADA", "value": "GREN" },
				{ "label": "GUAM", "value": "GUAM" },
				{ "label": "GUATEMALA", "value": "GUAT" },
				{ "label": "GUINEA", "value": "GNEA" },
				{ "label": "GUINEA - BISSAU", "value": "GUIB" },
				{ "label": "GUYANA", "value": "GUY" },
				{ "label": "HAITI", "value": "HAT" },
				{ "label": "HEARD AND MCDONALD ISLANDS", "value": "HMD" },
				{ "label": "HOLY SEE (VATICAN CITY)", "value": "VAT" },
				{ "label": "HONDURAS", "value": "HOND" },
				{ "label": "HONG KONG BNO", "value": "HOKO" },
				{ "label": "HONG KONG SAR", "value": "HNK" },
				{ "label": "HOWLAND ISLAND", "value": "XHI" },
				{ "label": "HUNGARY", "value": "HUNG" },
				{ "label": "ICELAND", "value": "ICLD" },
				{ "label": "IN THE AIR", "value": "XIR" },
				{ "label": "INDIA", "value": "IND" },
				{ "label": "INDONESIA", "value": "IDSA" },
				{ "label": "IRAN", "value": "IRAN" },
				{ "label": "IRAQ", "value": "IRAQ" },
				{ "label": "IRELAND", "value": "IRE" },
				{ "label": "ISRAEL", "value": "ISRL" },
				{ "label": "ITALY", "value": "ITLY" },
				{ "label": "JAMAICA", "value": "JAM" },
				{ "label": "JAPAN", "value": "JPN" },
				{ "label": "JERUSALEM", "value": "JRSM" },
				{ "label": "JORDAN", "value": "JORD" },
				{ "label": "KAZAKHSTAN", "value": "KAZ" },
				{ "label": "KENYA", "value": "KENY" },
				{ "label": "KIRIBATI", "value": "KIRI" },
				{ "label": "KOREA, DEMOCRATIC REPUBLIC OF (NORTH)", "value": "PRK" },
				{ "label": "KOREA, REPUBLIC OF (SOUTH)", "value": "KOR" },
				{ "label": "KOSOVO", "value": "KSV" },
				{ "label": "KUWAIT", "value": "KUWT" },
				{ "label": "KYRGYZSTAN", "value": "KGZ" },
				{ "label": "LAOS", "value": "LAOS" },
				{ "label": "LATVIA", "value": "LATV" },
				{ "label": "LEBANON", "value": "LEBN" },
				{ "label": "LESOTHO", "value": "LES" },
				{ "label": "LIBERIA", "value": "LIBR" },
				{ "label": "LIBYA", "value": "LBYA" },
				{ "label": "LIECHTENSTEIN", "value": "LCHT" },
				{ "label": "LITHUANIA", "value": "LITH" },
				{ "label": "LUXEMBOURG", "value": "LXM" },
				{ "label": "MACAU", "value": "MAC" },
				{ "label": "MACEDONIA, NORTH", "value": "MKD" },
				{ "label": "MADAGASCAR", "value": "MADG" },
				{ "label": "MALAWI", "value": "MALW" },
				{ "label": "MALAYSIA", "value": "MLAS" },
				{ "label": "MALDEN ISLAND", "value": "MLDI" },
				{ "label": "MALDIVES", "value": "MLDV" },
				{ "label": "MALI", "value": "MALI" },
				{ "label": "MALTA", "value": "MLTA" },
				{ "label": "MARSHALL ISLANDS", "value": "RMI" },
				{ "label": "MAURITANIA", "value": "MAUR" },
				{ "label": "MAURITIUS", "value": "MRTS" },
				{ "label": "MAYOTTE", "value": "MYT" },
				{ "label": "MEXICO - AGUASCALIENTES", "value": "AGS" },
				{ "label": "MEXICO - BAJA CALIFORNIA NORTE", "value": "BC" },
				{ "label": "MEXICO - BAJA CALIFORNIA SUR", "value": "BCSR" },
				{ "label": "MEXICO - CAMPECHE", "value": "CAMP" },
				{ "label": "MEXICO - CHIAPAS", "value": "CHIS" },
				{ "label": "MEXICO - CHIHUAHUA", "value": "CHIH" },
				{ "label": "MEXICO - COAHUILA", "value": "COAH" },
				{ "label": "MEXICO - COLIMA", "value": "COLI" },
				{ "label": "MEXICO - DISTRITO FEDERAL", "value": "DF" },
				{ "label": "MEXICO - DURANGO", "value": "DGO" },
				{ "label": "MEXICO - GUANAJUATO", "value": "GTO" },
				{ "label": "MEXICO - GUERRERO", "value": "GRO" },
				{ "label": "MEXICO - HIDALGO", "value": "HGO" },
				{ "label": "MEXICO - JALISCO", "value": "JAL" },
				{ "label": "MEXICO - MICHOACAN", "value": "MCH" },
				{ "label": "MEXICO - MORELOS", "value": "MOR" },
				{ "label": "MEXICO - NAYARIT", "value": "NAY" },
				{ "label": "MEXICO - NUEVO LEON", "value": "NL" },
				{ "label": "MEXICO - OAXACA", "value": "OAX" },
				{ "label": "MEXICO - PUEBLA", "value": "PUE" },
				{ "label": "MEXICO - QUERETARO", "value": "QRO" },
				{ "label": "MEXICO - QUINTANA ROO", "value": "QROO" },
				{ "label": "MEXICO - SAN LUIS POTOSI", "value": "SLP" },
				{ "label": "MEXICO - SINALOA", "value": "SIN" },
				{ "label": "MEXICO - SONORA", "value": "SON" },
				{ "label": "MEXICO - STATE OF MEXICO", "value": "MXCO" },
				{ "label": "MEXICO - TABASCO", "value": "TAB" },
				{ "label": "MEXICO - TAMAULIPAS", "value": "TAMP" },
				{ "label": "MEXICO - TLAXCALA", "value": "TLAX" },
				{ "label": "MEXICO - VERACRUZ", "value": "VER" },
				{ "label": "MEXICO - YUCATAN", "value": "YUC" },
				{ "label": "MEXICO - ZACATECAS", "value": "ZAC" },
				{ "label": "MICRONESIA", "value": "FSM" },
				{ "label": "MIDWAY ISLANDS", "value": "MDWI" },
				{ "label": "MOLDOVA", "value": "MLD" },
				{ "label": "MONACO", "value": "MON" },
				{ "label": "MONGOLIA", "value": "MONG" },
				{ "label": "MONTENEGRO", "value": "MTG" },
				{ "label": "MONTSERRAT", "value": "MONT" },
				{ "label": "MOROCCO", "value": "MORO" },
				{ "label": "MOZAMBIQUE", "value": "MOZ" },
				{ "label": "NAMIBIA", "value": "NAMB" },
				{ "label": "NAURU", "value": "NAU" },
				{ "label": "NEPAL", "value": "NEP" },
				{ "label": "NETHERLANDS", "value": "NETH" },
				{ "label": "NEW CALEDONIA", "value": "NCAL" },
				{ "label": "NEW ZEALAND", "value": "NZLD" },
				{ "label": "NICARAGUA", "value": "NIC" },
				{ "label": "NIGER", "value": "NIR" },
				{ "label": "NIGERIA", "value": "NRA" },
				{ "label": "NIUE", "value": "NIUE" },
				{ "label": "NORFOLK ISLAND", "value": "NFK" },
				{ "label": "NORTH MARIANA ISLANDS", "value": "MNP" },
				{ "label": "NORTHERN IRELAND", "value": "NIRE" },
				{ "label": "NORWAY", "value": "NORW" },
				{ "label": "OMAN", "value": "OMAN" },
				{ "label": "PAKISTAN", "value": "PKST" },
				{ "label": "PALAU", "value": "PALA" },
				{ "label": "PALMYRA ATOLL", "value": "PLMR" },
				{ "label": "PANAMA", "value": "PAN" },
				{ "label": "PAPUA NEW GUINEA", "value": "PNG" },
				{ "label": "PARAGUAY", "value": "PARA" },
				{ "label": "PERU", "value": "PERU" },
				{ "label": "PHILIPPINES", "value": "PHIL" },
				{ "label": "PITCAIRN ISLANDS", "value": "PITC" },
				{ "label": "POLAND", "value": "POL" },
				{ "label": "PORTUGAL", "value": "PORT" },
				{ "label": "PUERTO RICO", "value": "PR" },
				{ "label": "QATAR", "value": "QTAR" },
				{ "label": "ROMANIA", "value": "ROM" },
				{ "label": "RUSSIA", "value": "RUS" },
				{ "label": "RWANDA", "value": "RWND" },
				{ "label": "SAINT MARTIN", "value": "MAF" },
				{ "label": "SAMOA", "value": "WSAM" },
				{ "label": "SAN MARINO", "value": "SMAR" },
				{ "label": "SAO TOME AND PRINCIPE", "value": "STPR" },
				{ "label": "SAUDI ARABIA", "value": "SARB" },
				{ "label": "SENEGAL", "value": "SENG" },
				{ "label": "SERBIA", "value": "SBA" },
				{ "label": "SEYCHELLES", "value": "SEYC" },
				{ "label": "SIERRA LEONE", "value": "SLEO" },
				{ "label": "SINGAPORE", "value": "SING" },
				{ "label": "SINT MAARTEN", "value": "STM" },
				{ "label": "SLOVAKIA", "value": "SVK" },
				{ "label": "SLOVENIA", "value": "SVN" },
				{ "label": "SOLOMON ISLANDS", "value": "SLMN" },
				{ "label": "SOMALIA", "value": "SOMA" },
				{ "label": "SOUTH AFRICA", "value": "SAFR" },
				{ "label": "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLAND", "value": "SGS" },
				{ "label": "SOUTH SUDAN", "value": "SSDN" },
				{ "label": "SPAIN", "value": "SPN" },
				{ "label": "SRI LANKA", "value": "SRL" },
				{ "label": "ST. BARTHELEMY", "value": "STBR" },
				{ "label": "ST. HELENA", "value": "SHEL" },
				{ "label": "ST. KITTS AND NEVIS", "value": "STCN" },
				{ "label": "ST. LUCIA", "value": "SLCA" },
				{ "label": "ST. PIERRE AND MIQUELON", "value": "SPMI" },
				{ "label": "ST. VINCENT AND THE GRENADINES", "value": "STVN" },
				{ "label": "SUDAN", "value": "SUDA" },
				{ "label": "SURINAME", "value": "SURM" },
				{ "label": "SVALBARD", "value": "SJM" },
				{ "label": "SWEDEN", "value": "SWDN" },
				{ "label": "SWITZERLAND", "value": "SWTZ" },
				{ "label": "SYRIA", "value": "SYR" },
				{ "label": "TAIWAN", "value": "TWAN" },
				{ "label": "TAJIKISTAN", "value": "TJK" },
				{ "label": "TANZANIA", "value": "TAZN" },
				{ "label": "THAILAND", "value": "THAI" },
				{ "label": "TIMOR-LESTE", "value": "TMOR" },
				{ "label": "TOGO", "value": "TOGO" },
				{ "label": "TOKELAU", "value": "TKL" },
				{ "label": "TONGA", "value": "TONG" },
				{ "label": "TRINIDAD AND TOBAGO", "value": "TRIN" },
				{ "label": "TUNISIA", "value": "TNSA" },
				{ "label": "TURKEY", "value": "TRKY" },
				{ "label": "TURKMENISTAN", "value": "TKM" },
				{ "label": "TURKS AND CAICOS ISLANDS", "value": "TCIS" },
				{ "label": "TUVALU", "value": "TUV" },
				{ "label": "UGANDA", "value": "UGAN" },
				{ "label": "UKRAINE", "value": "UKR" },
				{ "label": "UNITED ARAB EMIRATES", "value": "UAE" },
				{ "label": "UNITED KINGDOM", "value": "GRBR" },
				{ "label": "UNITED STATES OF AMERICA", "value": "USA" },
				{ "label": "URUGUAY", "value": "URU" },
				{ "label": "UZBEKISTAN", "value": "UZB" },
				{ "label": "VANUATU", "value": "VANU" },
				{ "label": "VENEZUELA", "value": "VENZ" },
				{ "label": "VIETNAM", "value": "VTNM" },
				{ "label": "VIRGIN ISLANDS (U.S.)", "value": "VI" },
				{ "label": "VIRGIN ISLANDS, BRITISH", "value": "BRVI" },
				{ "label": "WAKE ISLAND", "value": "WKI" },
				{ "label": "WALLIS AND FUTUNA ISLANDS", "value": "WAFT" },
				{ "label": "WEST BANK", "value": "XWB" },
				{ "label": "WESTERN SAHARA", "value": "SSAH" },
				{ "label": "YEMEN", "value": "YEM" },
				{ "label": "ZAMBIA", "value": "ZAMB" },
				{ "label": "ZIMBABWE", "value": "ZIMB" }
			]      
		}
	},
	had_us_visa: {
		answer: {
			type: "yes-no-buttons"
		},
		lost: {
			answer: {
				type: "yes-no-buttons"
			},
			year: {
				type: "number",
				props: {
					label: "Year",
					min: 1900,
					max: DateTime.now().year
				}
			},
			how: {
				type: "textarea",
				props: {
					label: "Please provide a brief description",
					maxLength: 4000
				}
			}
		},
		cancelled: {
			answer: {
				type: "yes-no-buttons"
			},
			description: {
				type: "textarea",
				props: {
					label: "Please provide a brief description",
					maxLength: 4000
				}
			}
		}
	},
	refused_us_visa: {
		answer: {
			type: "yes-no-buttons"
		},
		description: {
			type: "textarea",
			props: {
				label: "Please provide a brief description",
				maxLength: 4000
			}
		}
	},
	immigrant_petition: {
		answer: {
			type: "yes-no-buttons"
		},
		description: {
			type: "textarea",
			props: {
				label: "Please provide a brief description",
				maxLength: 4000
			}
		}
	},
	us_dl_holder: {
		answer: {
			type: "yes-no-buttons"
		},
		list: {
			type: "array",
			fieldArray: {
				fieldGroup: [
					{
						key: "number",
						type: "input",
						props: {
							label: "Driver's License Number",
							maxLength: 20
						}
					},
					{
						key: "state",
						type: "state-province-autocomplete",
						props: {
							parentValue: "US"
						}
					}
				]
			}
		}
	},
	visited_us_before: {
		answer: {
			type: "yes-no-buttons"
		},
		list: {
			type: "array",
			fieldArray: {
				fieldGroup: [
					{
						key: "date_of_visit",
						type: "datepicker",
						props: {
							label: "Date of Visit",
						}
					},
					{
						template: "<div class=\"gwc-form__label\">How long did you stay in the United States?</div>"
					},
					{
						fieldGroup: [
							{
								key: "duration.count",
								type: "number",
								props: {
									label: "Duration",
								}
							},
							{
								key: "duration.type",
								type: "select",
								props: {
									label: "Duration Type",
									options: duration_options
								}
							}
						]
					},
					
				]
			}
		}
	},
}

export const US_APPLICATION_FIELDS = {
	previous_visa: {
		date_of_issue: {
			type: "datepicker",
			props: {
				label: "Date of Issue",
			}
		},
		same_type: {
			type: "yes-no-buttons",
		},
		same_location: {
			type: "yes-no-buttons",
		}
	},
	number: {
		type: "input",
		props: {
			label: "Visa Number",
			maxLength: 12
		}
	},
	traveling_with: {
		not_alone: {
			type: "yes-no-buttons",
		},
		group: {
			type: "yes-no-buttons",
		},
		group_name: {
			type: "input",
			props: {
				label: "Group Name",
				maxLength: 75
			}
		},
		companions_list: {
			type: "array",
			fieldArray: {
				fieldGroup: [
					{
						fieldGroup: [
							{
								key: "first_name",
								type: "name-field",
								props: {
									label: "First Name",
								},
								className: "gwc-form__field gwc-form__field--grow"
							},
							{
								key: "middle_name",
								type: "name-field",
								props: {
									label: "Middle Name",
								},
								className: "gwc-form__field gwc-form__field--grow"
							},
							{
								key: "last_name",
								type: "name-field",
								props: {
									label: "Last Name",
								},
								className: "gwc-form__field gwc-form__field--grow"
							}
						],
						fieldGroupClassName: "gwc-form__field-group gwc-form__field-group--row"
					},
					{
						key: "relationship",
						type: "select",
						props: {
							label: "Relationship",
							options: [
								{ label: "Parent", value: "P" },
								{ label: "Spouse", value: "S" },
								{ label: "Child", value: "C" },
								{ label: "Other Relative", value: "R" },
								{ label: "Friend", value: "F" },
								{ label: "Business Associate", value: "B" },
								{ label: "Other", value: "O" }
							]
						}
					}
				]
			}
		}
	},
	paying_party: {
		type: {
			type: "select",
			props: {
				label: "Paying Party",
				options: [
					{
						label: "Self",
						value: "S"
					},
					{
						label: "Present Employer",
						value: "P"
					},
					{
						label: "Employer in the United States",
						value: "U"
					},
					{
						label: "Other Company/Organization",
						value: "C"
					},
					{
						label: "Other Person",
						value: "O"
					}
				]
			}
		},
		other_company: {
			name: {
				type: "input",
				props: {
					label: "Company/Organization Name",
					maxLength: 33
				}
			},
			phone_number: {
				type: "input",
				props: {
					label: "Phone Number",
					maxLength: 15
				}
			},
			relationship: {
				type: 'input',
				props: {
					label: "Relationship",
					maxLength: 50
				}
			},
			address: {
				fieldGroup: INT_ADDRESS_FIELDS
			}
		},
		other_person: {
			first_name: {
				type: "name-field",
				props: {
					label: "First Name",
				}
			},
			middle_name: {
				type: "name-field",
				props: {
					label: "Middle Name",
				}
			},
			last_name: {
				type: "name-field",
				props: {
					label: "Last Name",
				}
			},
			phone_number: {
				type: "masked-input",
				props: {
					mask: "(000) 000-0000",
					label: "Phone Number",
				}
			},
			email: {
				type: "input",
				props: {
					label: "Email",
					pattern: "\\w+([\\-+._']\\w+)*@\\w+([\\-._]\\w+)*\\.\\w+([\\-.]\\w+)*",
					maxLength: 33
				}
			},
			relationship: {
				type: "select",
				props: {
					label: "Relationship",
					options: [
						{ label: "Child", value: "C" },
						{ label: "Parent", value: "P" },
						{ label: "Spouse", value: "S" },
						{ label: "Other Relative", value: "R" },
						{ label: "Friend", value: "F" },
						{ label: "Other", value: "O" }
					]
				}
			},
			same_address: {
				type: "yes-no-buttons",
			},
			address: {
				fieldGroup: INT_ADDRESS_FIELDS
			}
		}
	},
	stay_duration: {
		days: {
			type: "number",
			props: {
				label: "Days",
			}
		},
		period: {
			type: "select",
			props: {
				label: "Period",
				options: duration_options
			}
		}
	},
	applying_at: {
		type: 'autocomplete',
		props: {
			label: 'Applying at',
			options: []
		}
	},
	travel_plans: {
		answer: {
			type: "yes-no-buttons"
		}
	},
	date_of_entry: {
		"type": "datepicker",
		"props": {
			"view": "multi-year",
			"after": [
				{
					"date": "now",
					"message": "Date can't be in the past."
				}
			],
			"label": "Date of Entry"
		}
	},
	address: {
		fieldGroup: US_ADDRESS_FIELDS
	},
	date_of_exit: {
		type: "datepicker",
		props: {
			view: "multi-year",
			after: [
				{
					key: "application.previous_visits.date_of_entry",
					parent: "global",
					message: "Date of Exit must be after Date of Entry."
				}
			],
			label: "Date of Exit",
			before: [
				{
					date: "now",
					message: "Date can't be in the future."
				}
			]
		}
	},
	arrival_flight: {
		type: 'input',
		props: {
			label: 'Arrival Flight',
			maxLength: 20
		}
	},
	arrival_city: {
		type: 'input',
		props: {
			label: 'Arrival City',
			maxLength: 20
		}
	},
	departure_flight: {
		type: 'input',
		props: {
			label: 'Departure Flight',
			maxLength: 20
		}
	},
	departure_city: {
		type: 'input',
		props: {
			label: 'Departure City',
			maxLength: 20
		}
	},
	cities_to_visit: {
		list: {
			"type": "multiple",
			"fieldArray": {
				"fieldGroup": [
					{
						"key": "city",
						"type": "name-field",
						"props": {
							"label": "City",
							"maxLength": 40,
							"required": true
						},
						"className": "gwc-form__field gwc-form__field--grow",
						"validation": {
							"messages": {
								"pattern": "Please use only letters, spaces, dashes and apostrophes."
							}
						}
					}
				]
			},
			"defaultValue": [
				null
			]
		}
	},
}